import * as requestFromServer from './pasoCuatroCrud';

import { pasoCuatroSlice, callTypes } from './pasoCuatroSlice';

const { actions } = pasoCuatroSlice;

export const fetchPasoCuatroAlTres = queryParams => async dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return await requestFromServer
        .postPasoCuatroAlTres(queryParams)
        .then(response => {
            const pasoCuatroAlTresInformacion = response.data;
            //console.log(pasoCuatroAlTresInformacion);
            dispatch(actions.pasoCuatroAlTresFetched({ pasoCuatroAlTresInformacion }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchErrorCuatroAlTres({ error, callType: callTypes.action }));
        });
};

export const fetchPasoCuatroAlCinco = queryParams => async dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return await requestFromServer
        .postPasoCuatroAlCinco(queryParams)
        .then(response => {
            const pasoCuatroAlCincoInformacion = response.data;
            //console.log(pasoCuatroAlCincoInformacion);
            dispatch(actions.pasoCuatroAlCincoFetched({ pasoCuatroAlCincoInformacion }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchErrorPasoCuatroAlCinco({ error, callType: callTypes.action }));
        });
};

export const stateLimpiar = queryParams => dispatch => {
    dispatch(actions.stateLimpiar());
};